import React from 'react'

export default function Item({item,deleteItem,isAll, changeQt}) {

  return (
    <div className="item">
        <h3 className="item-name">{item.Name}</h3>
        {!isAll &&<h4><button className="quantity-edit" onClick={() => changeQt(item,false)}>➖</button>{item.Quantity}<button className="quantity-edit" onClick={() => changeQt(item,true)}>➕</button></h4>}
        {isAll &&<h4>{item.Quantity}</h4>}
       {isAll && <h4 className="bag-name">{item.Bag}</h4>}
        <button className="suppBag" onClick={() => deleteItem(item.ID)}>❌</button>
    </div>
  )
}
